<div class="grid-x grid-margin-x">
  <div class="cell small-12">
    <label>
      OrganizationId:
      <input type="text" [(ngModel)]="seConfiguration.organizationId" />
    </label>
  </div>
</div>
<div class="cell small-12">
  Select the event type for the history entry:
</div>
<div class="cell small-12">
  <select [(ngModel)]="selectedEventType">
    @for (option of historyEntryTypes; track option) {
      <option [value]="option.number">{{option.word}}</option>
    }
  </select>
</div>